import React from "react";

const ContactUsIcon: React.FC<{ color?: string }> = ({ color = "currentColor" }) => (
  <>
    {/* Outer chat bubble shape */}
    <path
      d="M4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7V14C20 15.6569 18.6569 17 17 17H9L4 21V7Z"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* Three dots */}
    <path
      d="M7.5 10.5h.01M12 10.5h.01M16.5 10.5h.01"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

export default ContactUsIcon;